import script from "./EmployersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployersPage.vue?vue&type=script&setup=true&lang=ts"

import "./EmployersPage.vue?vue&type=style&index=0&id=e863ef54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e863ef54"]])

export default __exports__